var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-count-up-text-circle"},[_c('div',{staticClass:"countup-circle"},[_c('div',{ref:"countField",staticClass:"text"},[_vm._v("0")])])])}
var staticRenderFns = []

export { render, staticRenderFns }